module.exports = __webpack_public_path__ + "img/chat-person-3.81b9ca2.png";